module.exports = __webpack_public_path__ + "img/HZGB03-01-02_1.8133f63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB03-01-02_1.png
// module id = 2A36
// module chunks = 0